// eslint-disable-next-line no-shadow
export enum TechStackLabel {
	React = `React`,
	TypeScript = `TypeScript`,
	ReactRouter6 = `React Router 6`,
	MUI = `MUI`,
	Emotion = `Emotion`,
	HTML5 = `HTML5`,
	CSS3 = `CSS3`,
	SASS = `SASS`,
}